import React, { Component, useRef, useState, useEffect } from "react"
import { loadingStatus } from "actions"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import settings from "settings"
import _ from "lodash"
import axios from "axios"
import { toast } from "react-toastify"
import LotModal from "containers/modals/lot"
import InfoWindow from "containers/mapping/infoWindowMapbox"
import SectionInfoWindow from "containers/mapping/sectionInfoWindow"
import currentUser from "helpers/currentUser"
import numeral from "numeral"
import Select from "react-select"
import NumberFormat from "react-number-format"
import ReactSelect from "components/ReactSelect"
import FullTable from "components/FullTable"
import getData from "helpers/asyncSubmitData"
import helpers from "helpers/helpers"
import moment from "moment"
import classNames from "classnames"
import calculateSectionHealth from "logic/sectionHealth"
import * as mapboxgl from "mapbox-gl"
import Modal from "react-responsive-modal"
import LotColumnIndex from "models/lotColumnIndex"
import translations from "translations/global"
import { SingleDatePicker } from "react-dates"
import Switch from "react-switch"
import "mapbox-gl/dist/mapbox-gl.css"

mapboxgl.accessToken = settings.mapboxKey

const zoomThreshold = 15 // this is the zoom level where it goes from sections to lots.

const Filter = (props) => {
	if (props.mode !== "filter") return null
	let user = currentUser()
	if (user.group !== 1) return null // insurance
	let quicks = [
		"Builder VDL",
		"Builder Assigned",
		"Developer VDL",
		"Under Construction",
		"Completed Specs",
		"Sale Pending",
	]
	const [low, setLow] = useState(null) // this is always used, like in text fields this is the value.  high is for low/high sets
	const [high, setHigh] = useState(null)
	const [defaultSelectOptions, setDefaultSelectOptions] = useState([])
	const [stageTypeValue, setStageTypeValue] = useState(false)
	const [lowFocused, setLowFocused] = useState(false) // for stupid datepicker
	const [highFocused, setHighFocused] = useState(false)
	const [selectOptions, setSelectOptions] = useState([])
	const [matchedList, setMatchedList] = useState([])
	const [selections, setSelections] = useState([])
	const [quickStat, setQuickStat] = useState([])
	const lotIndex = LotColumnIndex()
	let type = _.get(stageTypeValue, "type")
	let opts = [] // if they select a Select (not date, text, etc)
	if (type == "select") {
		if (stageTypeValue && stageTypeValue.opts) {
			opts = _.map(stageTypeValue.opts, (v) => {
				return { label: v, value: v }
			})
		} else if (stageTypeValue && stageTypeValue.global) {
			//? Global is like site types - culdesac, corner etc.  Things that are in every property.  Mark Global = true in lotcolumnindex.js
			_.forEach(props.payload.public[stageTypeValue.public], (v) => {
				opts.push({ label: v.name, value: v.id })
			})
		} else if (stageTypeValue && stageTypeValue.public) {
			_.forEach(props.payload.public[stageTypeValue.public], (v) => {
				if (v.property && v.property == props.activeProperties[0]) {
					opts.push({ label: v.name, value: v.id })
				} else if (
					v.properties &&
					Array.isArray(v.properties) &&
					v.properties.includes(props.activeProperties[0])
				) {
					opts.push({ label: v.name, value: v.id })
				}
			})
		}
	}

	useEffect(() => {
		if (props.payloadStatus && props.activeProperties.length == 1 && selectOptions.length === 0) load()
	}, [props.payloadStatus])

	useEffect(() => {
		props.filterChange(selections)
	}, [selections])

	useEffect(() => {
		props.quickStatChange(quickStat)
		//setSelections([])
	}, [quickStat])

	const load = () => {
		if (!props.activeProperties.length == 1) return
		let opts = []
		_.forEach(lotIndex, (v) => {
			let ind = _.findIndex(translations, { name: v.id })
			// Split is due to the ids having the sql, such as b.primary_first, so check for that
			let split = v.id.split(".")
			let splitIndex
			if (split.length > 1) {
				splitIndex = _.findIndex(translations, { name: split[1] })
			}
			if (v.Label) {
				v.english = v.Label
				opts.push(v)
			} else if (ind !== -1) {
				v.english = translations[ind].english
				opts.push(v)
			} else if (splitIndex && splitIndex !== -1) {
				v.english = translations[splitIndex].english
				opts.push(v)
			} else {
				v.english = _.startCase(v.id.replace("_", " "))
				opts.push(v)
			}
		})
		let f = _.map(opts, (v) => {
			return { label: v.english, value: v.id, ...v }
		})
		f = _.sortBy(f, "english")
		setSelectOptions(f)
		setDefaultSelectOptions(f)
	}

	const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
		let opts = []
		let currentYear = moment().year() + 2
		for (let i = currentYear - 25; i <= currentYear; i++) {
			opts.push(
				<option value={i} key={i}>
					{i}
				</option>
			)
		}
		return (
			<div style={{ display: "flex", justifyContent: "center" }}>
				<div>
					<select value={month.month()} onChange={(e) => onMonthSelect(month, e.target.value)}>
						{moment.months().map((label, value) => (
							<option value={value} key={value}>
								{label}
							</option>
						))}
					</select>
				</div>
				<div>
					<select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
						{opts}
					</select>
				</div>
			</div>
		)
	}

	const apply = () => {
		let cur = _.cloneDeep(selections)
		cur.push({
			type: stageTypeValue.type,
			english: stageTypeValue.english,
			id: stageTypeValue.id,
			low,
			high: high || null,
		})
		// Remove all selected options from teh dropdown list
		let opts = _.cloneDeep(selectOptions)
		opts = _.filter(opts, (v) => {
			let check = _.findIndex(cur, { id: v.id })
			if (check === -1) return true
		})
		setSelectOptions(opts)
		setSelections(cur)
		setStageTypeValue(false)
		setLow(null)
		setHigh(null)
	}

	const removeFilter = (v) => {
		let sel = _.cloneDeep(selections)
		let ret = _.filter(sel, (r) => r.id !== v.id)
		setSelections(ret)

		// Add option back to select dropdown
		let opts = _.cloneDeep(defaultSelectOptions)
		let options = _.filter(opts, (v) => {
			let check = _.findIndex(ret, { id: v.id })
			if (check == -1) return true
		})
		setSelectOptions(options)
	}

	const editFilter = (v) => {
		let cloned = _.clone(selections)
		cloned = _.filter(cloned, (r) => r.id !== v.id)
		setSelections(cloned)
		let edited = _.find(defaultSelectOptions, { id: v.id })
		setStageTypeValue(edited)
		if (v.low) setLow(v.low)
		if (v.high) setHigh(v.high)
	}

	const buildCurrent = () => {
		let ret = []
		_.forEach(selections, (v) => {
			let el
			let styles = `px-2 py-2 bg-white border-dotted border-b-slate-600 my-2 hover:bg-rose-100 transition-colors`
			const Actions = () => (
				<div className="flex justify-end absolute top-0 right-0 pr-2 pt-1 z-20">
					<div className="text-xs font-bold text-red-500 cursor-pointer" onClick={() => editFilter(v)}>
						Edit
					</div>
					<div className="text-xs font-bold text-red-500 pl-2 cursor-pointer" onClick={() => removeFilter(v)}>
						Remove
					</div>
				</div>
			)
			if (v.type == "number") {
				let low = numeral(v.low).format(v.format)
				let high = numeral(v.high).format(v.format)
				el = (
					<div className={styles} key={_.random(1, 9999999)}>
						<Actions />
						<div className="text-sm font-bold blue">{v.english}</div> <span>between</span>
						<div className="text-sm font-bold blue">
							{low} - {high}
						</div>
					</div>
				)
			} else if (v.type == "date") {
				let start = v.low.format("M/DD/YY")
				let end = v.high.format("M/DD/YY")
				el = (
					<div className={styles} key={_.random(1, 9999999)}>
						<Actions />
						<div className="text-sm font-bold blue">{v.english}</div> <span>between</span>
						<div className="text-sm font-bold blue">
							{start} - {end}
						</div>
					</div>
				)
			} else if (v.type == "text") {
				el = (
					<div className={styles} key={_.random(1, 9999999)}>
						<Actions />
						<div className="text-sm font-bold blue">{v.english}</div> <span>like</span>
						<div className="text-sm font-bold blue">{v.low}</div>
					</div>
				)
			} else if (v.type == "boolean") {
				el = (
					<div className={styles} key={_.random(1, 9999999)}>
						<Actions />
						<div className="text-sm font-bold blue">{v.english}</div> <span>is</span>
						<div className="text-sm font-bold blue">{v.low}</div>
					</div>
				)
			} else if (v.type == "select") {
				let options = _.map(v.high, (r) => r.label)
				let opts = (Array.isArray(options) && options.join(", ")) || ""
				el = (
					<div className={styles} key={_.random(1, 9999999)}>
						<Actions />
						<div className="text-sm font-bold blue">{v.english}</div> <span>is</span>
						<div className="text-sm font-bold blue">{opts}</div>
					</div>
				)
			}
			ret.push(el)
		})
		return ret
	}

	const getFilteredLotCount = () => {
		if (!props.payload?.exec?.lots) return 0

		const lots = props.payload.exec.lots
		let activeCount = 0

		// Count lots that match quick filters
		if (quickStat && quickStat.length > 0) {
			lots.forEach((lot) => {
				let isActive = false
				
				quickStat.forEach((stat) => {
					switch (stat) {
						case "Builder Assigned":
							if (!lot.takedown_date && lot.builder) isActive = true
							break
						case "Builder VDL":
							if (helpers.isBuilderVDL(lot, null)) isActive = true
							break
						case "Developer VDL":
							if (!lot.takedown_date) isActive = true
							break
						case "Under Construction":
							if (lot.start_date && !lot.complete_date) isActive = true
							break
						case "Completed Specs":
							if (lot.complete_date && !lot.closing_date) isActive = true
							break
						case "Sale Pending":
							if (lot.sale_id && !lot.closing_date) isActive = true
							break
					}
				})
				
				if (isActive) activeCount++
			})
		}
		// Count lots that match advanced filters
		else if (selections && selections.length > 0) {
			lots.forEach((lot) => {
				let accepted = true
				
				selections.forEach((filter) => {
					let id = filter.id
					if (filter?.id?.includes(".")) id = filter.id.split(".")[1]
					
					const lotVal = lot[id]
					let skip = false
					
					try {
						// Special cases
						if (filter.id === "lot_status") {
							if (filter.low.includes("Available Home")) {
								if (!lot.sale_id && lot.takedown_date && lot.builder && lot.start_date && lot.complete_date && !lot.model) {
									skip = true
								}
							}
							if (filter.low.includes("Under Construction")) {
								if (!lot.sale_id && lot.takedown_date && lot.builder && lot.start_date && !lot.complete_date) {
									skip = true
								}
							}
						}
						
						if (!skip) {
							// Text filters
							if (filter.type === "text") {
								if (!lotVal || !lotVal.toLowerCase().includes(filter.low.toLowerCase())) {
									accepted = false
								}
							}
							// Select filters
							else if (filter.type === "select") {
								if (filter.low && lotVal !== filter.low) {
									accepted = false
								}
							}
							// Date filters
							else if (filter.type === "date") {
								const lotDate = new Date(lotVal)
								const filterDate = new Date(filter.low)
								if (filter.low && lotDate < filterDate) {
									accepted = false
								}
								if (filter.high) {
									const filterHighDate = new Date(filter.high)
									if (lotDate > filterHighDate) {
										accepted = false
									}
								}
							}
							// Number filters
							else if (filter.type === "number") {
								const lotNum = parseFloat(lotVal)
								if (filter.low && lotNum < parseFloat(filter.low)) {
									accepted = false
								}
								if (filter.high && lotNum > parseFloat(filter.high)) {
									accepted = false
								}
							}
						}
					} catch (e) {
						accepted = false
					}
				})
				
				if (accepted) activeCount++
			})
		}
		// No filters active - return total count
		else {
			activeCount = lots.length
		}

		return activeCount
	}

	return (
		<div className="filter-options">
			{props.lotData && (
				<h3 className="bg-blue w-full px-1 py-2 text-white text-base font-medium mb-2 flex justify-between">
					<span>Lot Info</span>
					<span
						className="font-bold text-sm mr-2 cursor-pointer"
						onClick={() => {
							props.setLotData(null)
							props.layerWork.resetLotBordersFeatureState()
						}}>
						X
					</span>
				</h3>
			)}
			<InfoWindow lot={props.lotData} openLot={props.openLot} />
			<h3 className="bg-blue w-full px-1 py-2 text-white text-base font-semibold">Quick Filters</h3>
			<div className="text-xs bg-blue py-1 text-white mb-2 px-1 mb-2">Total Lots: {getFilteredLotCount()}</div>
			<ul className="lotStatus__quick">
				{quicks.map((quick, index) => (
					<li
						className={classNames({
							active: quickStat.includes(quick),
						})}
						key={index}
						onClick={() => {
							setSelections([])
							load()
							setQuickStat((prev) => {
								if (prev.includes(quick)) {
									return prev.filter((stat) => stat !== quick)
								}
								return [...(prev || []), quick]
							})
						}}>
						<span>{quick}</span>
					</li>
				))}
			</ul>
			<h3 className="bg-blue w-full px-1 py-2 text-white text-base font-semibold mb-2 mt-4">Filters</h3>
			{/* Current Selections */}
			<div className="">{buildCurrent()}</div>
			<div className="pt-4">
				<Select
					value={stageTypeValue}
					options={selectOptions}
					onChange={(v) => {
						setQuickStat([])
						setStageTypeValue(v)
					}}
					isClearable={true}
				/>
				{type == "number" && (
					<div className="flex py-6">
						<NumberFormat
							thousandSeparator={true}
							onValueChange={(v) => setLow(v.value)}
							placeholder="Low"
							className="mr-4 input"
							value={low}
						/>
						<NumberFormat
							thousandSeparator={true}
							onValueChange={(v) => setHigh(v.value)}
							placeholder="High"
							className="input"
							value={high}
						/>
					</div>
				)}
				{type == "date" && (
					<div className="flex py-6">
						<div className="mr-4">
							<SingleDatePicker
								id="lowDate"
								focused={lowFocused} //so dumb
								onFocusChange={({ focused }) => setLowFocused(focused)}
								numberOfMonths={1}
								date={low}
								renderMonthElement={renderMonthElement}
								onDateChange={(v) => {
									setLow(v)
								}}
								placeholder="Start Date"
								isOutsideRange={(day) => {
									return false
								}}
							/>
						</div>
						<div>
							<SingleDatePicker
								id="highDate"
								focused={highFocused} //so dumb
								onFocusChange={({ focused }) => setHighFocused(focused)}
								numberOfMonths={1}
								date={high}
								renderMonthElement={renderMonthElement}
								onDateChange={(v) => {
									setHigh(v)
								}}
								placeholder="End Date"
								isOutsideRange={(day) => {
									return false
								}}
							/>
						</div>
					</div>
				)}
				{type == "text" && (
					<div className="flex py-6">
						<input
							type="text"
							value={low || ""}
							className="input border-blue border"
							onChange={(e) => {
								setLow(e.target.value)
							}}
						/>
					</div>
				)}
				{type == "boolean" && (
					<div className="py-6">
						<Select
							value={high} // This is temp storage, low is the actual value
							options={[
								{ value: false, label: "No" },
								{ value: true, label: "Yes" },
							]}
							onChange={(v) => {
								setLow(v.label)
								setHigh(v)
							}}
							isClearable={true}
						/>
					</div>
				)}
				{type == "select" && (
					<div className="py-6">
						<Select
							value={high} // This is temp storage, low is the actual value
							options={opts}
							onChange={(v) => {
								setLow(_.map(v, (r) => r.value))
								setHigh(v)
							}}
							isMulti={true}
							isClearable={true}
						/>
					</div>
				)}
				{low && (
					<div className="btn-success text-center py-2 px-4 w-full cursor-pointer" onClick={apply}>
						APPLY
					</div>
				)}
			</div>
		</div>
	)
}

function LotStatus(props) {
	if (props.activeProperties.length !== 1)
		return (
			<div className="text-center pt-24 text-4xl text-blue">
				Please select one property to view the status map.
			</div>
		)
	const [lot, setLot] = useState(false)
	const [lat, setLat] = useState("")
	const [lng, setLng] = useState("")
	const [zoom, setZoom] = useState(14)
	const [mode, setMode] = useState("status")
	const [currentProperty, setCurrentProperty] = useState("")
	const [modal, setModal] = useState(false)
	const [lotData, setLotData] = useState(false)
	const [editOpen, setEditOpen] = useState(false)
	const [modalData, setModalData] = useState(null)
	const [window, setWindow] = useState(false)
	const [infoLat, setInfoLat] = useState("")
	const [infoLng, setInfoLng] = useState("")
	const [section, setSection] = useState("")
	const [fullPropertyData, setFullPropertyData] = useState(null)
	const [sectionInfoLat, setSectionInfoLat] = useState("")
	const [sectionInfoLng, setSectionInfoLng] = useState("")
	const [infoWindowStatus, setInfoWindowStatus] = useState(false)
	const [sectionInfoWindowStatus, setSectionInfoWindowStatus] = useState(false)
	const [reloadMap, setReloadMap] = useState(false)
	const [editingLots, setEditingLots] = useState([])
	const [showAerial, setShowAerial] = useState(false)
	const [droneMode, setDroneMode] = useState(false)
	const [showingLots, setShowingLots] = useState(true)
	const [showingLabels, setShowingLabels] = useState(true)
	const [aerialData, setAerialData] = useState(null)
	const [lotLabels, setLotLabels] = useState({ value: "builder", label: "Builders" })
	const lotLabelsRef = useRef({ value: "builder", label: "Builders" })
	const [showFilters, setShowFilters] = useState({
		section: false,
		builder: false,
	})
	const [sectionFilters, setSectionFilters] = useState([])
	const [builderFilters, setBuilderFilters] = useState([])
	const [colors, setColors] = useState({
		builderNoTakedown: "#1aa1ff",
		takedown: "#805203",
		developer: "white",
		start: "#c1c810",
		complete: "#ee8723",
		closed: "#818181",
		model: "#7a0b9e",
		highlighted: "#C0FD05",
	})
	const [user, setUser] = useState(currentUser())
	const [currentPos, setCurrentPos] = useState({
		lat: 0,
		lng: 0,
		zoom: 0,
	})
	const [map, setMap] = useState(null)
	const [labels, setLabels] = useState([])
	const [mapType, setMapType] = useState("mapbox://styles/mapbox/standard")
	const mapContainer = React.createRef()
	const lotsGeoRef = useRef(null)
	const pendingCenters = useRef(null)
	const lotStatusBySectionColumns = [
		{
			Header: "Section",
			accessor: "section",
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Lots Loaded",
			accessor: "total",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.total
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Platted Lots",
			accessor: "platted_lots",
			Footer: (props) => helpers.tableTotals(props, "platted_lots", "0,0"),
		},
		{
			Header: "Homes Sold",
			accessor: "sold",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.sold
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Homes Closed",
			accessor: "closed",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.closed
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Builder Lots",
			accessor: "builder_owned",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.builder_owned
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Developer Holds",
			accessor: "dev_owned",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.dev_owned
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},

		{
			Header: "Sales Opportunities",
			accessor: "salesOps",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.salesOps
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Percent Sold/Closed",
			accessor: "percent_sold",
			show: true,
			Cell: (v) => {
				if (v.value) {
					return numeral(v.value).format("0.00%")
				}
				return ""
			},
		},
		{
			Header: "VDL - Builder",
			accessor: "vdl_builder",
			Footer: (props) => helpers.tableTotals(props, "vdl_builder", "0,0"),
		},
		{
			Header: "VDL - Developer",
			accessor: "vdl_developer",
			Footer: (props) => helpers.tableTotals(props, "vdl_developer", "0,0"),
		},
		{
			Header: "Specs Under Construction",
			accessor: "specs_uc",
			Footer: (props) => helpers.tableTotals(props, "specs_uc", "0,0"),
		},
		{
			Header: "Spec Complete",
			accessor: "specs_complete",
			Footer: (props) => helpers.tableTotals(props, "specs_complete", "0,0"),
		},
		{
			Header: "Buyer Under Construction",
			accessor: "buyer_uc",
			Footer: (props) => helpers.tableTotals(props, "buyer_uc", "0,0"),
		},
		{
			Header: "Buyer Complete",
			accessor: "buyer_complete",
			Footer: (props) => helpers.tableTotals(props, "buyer_complete", "0,0"),
		},
	]

	const lotStatusByBuilderColumns = [
		{
			Header: "Builder",
			accessor: "builder",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Lot Type",
			accessor: "lot_type",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Lots Loaded",
			accessor: "total",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.total
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Homes Sold",
			accessor: "sold",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.sold
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Homes Closed",
			accessor: "closed",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.closed
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Builder Lots",
			accessor: "builderOwned",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.builderOwned
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Percent Sold/Closed",
			accessor: "percent_sold",
			Cell: (v) => {
				if (v.value) {
					return numeral(v.value).format("0.00%")
				}
				return ""
			},
		},
		{
			Header: "VDL",
			accessor: "vdl",
			Footer: (props) => helpers.tableTotals(props, "vdl", "0,0"),
		},
		{
			Header: "Specs Under Construction",
			accessor: "specs_uc",
			Footer: (props) => helpers.tableTotals(props, "specs_uc", "0,0"),
		},
		{
			Header: "Spec Complete",
			accessor: "specs_complete",
			Footer: (props) => helpers.tableTotals(props, "specs_complete", "0,0"),
		},
		{
			Header: "Buyer Under Construction",
			accessor: "buyer_uc",
			Footer: (props) => helpers.tableTotals(props, "buyer_uc", "0,0"),
		},
		{
			Header: "Buyer Complete",
			accessor: "buyer_complete",
			Footer: (props) => helpers.tableTotals(props, "buyer_complete", "0,0"),
		},
	]

	const paintProperties = {
		fillColors: {
			status: [
				"case",
				["boolean", ["feature-state", "highlighted"], false],
				colors.highlighted,
				["==", ["get", "model"], 1],
				colors.model,
				["!=", ["get", "closing_date"], null],
				colors.closed,
				["all", ["!=", ["get", "builder"], null], ["==", ["get", "takedown_date"], null]],
				colors.builderNoTakedown,
				["!", ["has", "takedown_date"]],
				colors.developer,
				["!=", ["get", "complete_date"], null],
				colors.complete,
				["!=", ["get", "start_date"], null],
				colors.start,
				["!=", ["get", "takedown_date"], null],
				colors.takedown,
				"#FFF",
			],
			edit: [
				"case",
				["boolean", ["feature-state", "active"], false],
				"#ff0000",
				["all", ["!=", ["get", "builder"], null], ["==", ["get", "takedown_date"], null]],
				colors.builderNoTakedown,
				["==", ["get", "model"], 1],
				colors.model,
				["!=", ["get", "closing_date"], null],
				colors.closed,
				["!", ["has", "takedown_date"]],
				colors.developer,
				["!=", ["get", "complete_date"], null],
				colors.complete,
				["!=", ["get", "start_date"], null],
				colors.start,
				["!=", ["get", "takedown_date"], null],
				colors.takedown,
				"#FFF",
			],
			filter: ["case", ["boolean", ["feature-state", "active"], false], "#1aa1ff", "#bbb"],
		},
		fillOpacity: {
			status: ["case", ["==", ["get", "model"], 1], 0.9, ["!=", ["get", "closing_date"], null], 0.5, 0.9],
			edit: ["case", ["boolean", ["feature-state", "active"], false], 1, 0.7],
			filter: ["case", ["boolean", ["feature-state", "active"], false], 0.9, 0.5],
		},
		lineColor: {
			status: ["case", ["boolean", ["feature-state", "active"], false], "#000", "#EFEFEF"],
			edit: ["case", ["boolean", ["feature-state", "never"], false], "#000", "#EFEFEF"],
			filter: [
				"case",
				["boolean", ["feature-state", "active"], false],
				"#312dba",
				["boolean", ["feature-state", "thickBorder"], false],
				"#000",
				"#ccc",
			],
		},
		lineWidth: {
			status: ["case", ["boolean", ["feature-state", "active"], false], 4, 2],
			edit: ["case", ["boolean", ["feature-state", "never"], false], 4, 2],
			filter: ["case", ["boolean", ["feature-state", "thickBorder"], false], 4, 2],
		},
	}

	const layerWork = {
		removePendingCircles: () => {
			if (map.getLayer("pending-sales-circle")) {
				map.removeLayer("pending-sales-circle")
			}
		},
		addPendingCircles: (map) => {
			map.addLayer({
				id: "pending-sales-circle",
				type: "circle",
				source: "pending-sales-centers",
				paint: {
					"circle-radius": 6,
					"circle-color": "#FF0000",
					"circle-stroke": "#666",
					"circle-stroke-width": 1,
					"circle-opacity": 0.7,
				},
			})
		},
		removeSections: () => {
			if (map.getLayer("sections")) {
				map.removeLayer("sections")
			}
			if (map.getLayer("sections-outline")) {
				map.removeLayer("sections-outline")
			}
		},
		resetLotBordersFeatureState: () => {
			if (!map || !map.getSource("lots")) return
			//? reset all features states on lot-borders back to false
			const features = lotsGeoRef.current.features
			features.forEach((feature) => {
				map.setFeatureState({ source: "lots", id: feature.id }, { active: false })
				map.setFeatureState({ source: "lots", id: feature.id }, { thickBorder: false })
			})
		},
		resetLotFeatureState: () => {
			if (!map || !map.getSource("lots")) return
			//? reset all features states on lots back to false
			const features = lotsGeoRef.current.features
			features.forEach((feature) => {
				map.setFeatureState({ source: "lots", id: feature.id }, { active: false })
			})
		},
		editInitFeatureStates: () => {
			if (!map || !map.getSource("lots")) return
			//? reset all features states on lots back to false
			const features = lotsGeoRef.current.features
			features.forEach((feature) => {
				map.setFeatureState({ source: "lots", id: feature.id }, { active: false })
			})
			_.forEach(editingLots, (lotId) => {
				map.setFeatureState({ source: "lots", id: lotId }, { active: true })
			})
		},
	}

	const mapClickEvents = {
		lots: {
			status: (e) => {
				let l = e.features[0].properties
				let lot = _.find(props.payload.exec.lots, { id: l.id })
				if (l.sales) lot.sales = JSON.parse(l.sales)
				if (l.buyers) lot.buyers = JSON.parse(l.buyers)
				// Set feature state for clicked lot
				// Clear any previously active lots
				const features = map.querySourceFeatures("lots")
				features.forEach((feature) => {
					map.setFeatureState({ source: "lots", id: feature.id }, { active: false })
				})
				// Set the new active lot
				setLotData((prev) => {
					if (prev && prev.id === lot.id) {
						return null
					}
					map.setFeatureState({ source: "lots", id: lot.id }, { active: true })
					return lot
				})
			},
			edit: (e) => {
				if (!e.features || !e.features.length) return
				let l = e.features[0].properties
				//let lot = _.find(props.payload.exec.lots, { id: l.id })
				// Toggle the lot in editingLots array
				const lotId = l.id
				setEditingLots((prevLots) => {
					const isSelected = prevLots.includes(lotId)
					// Update map feature state
					map.setFeatureState({ source: "lots", id: lotId }, { active: !isSelected })
					// Return updated array
					return isSelected ? prevLots.filter((lot) => lot !== lotId) : [...prevLots, lotId]
				})
			},
			filter: (e) => {
				let l = e.features[0].properties
				let lot = _.find(props.payload.exec.lots, { id: l.id })
				if (l.sales) lot.sales = JSON.parse(l.sales)
				if (l.buyers) lot.buyers = JSON.parse(l.buyers)
				// Set feature state for clicked lot
				// Clear any previously active lots
				const features = map.querySourceFeatures("lots")
				features.forEach((feature) => {
					map.setFeatureState({ source: "lots", id: feature.id }, { thickBorder: false })
				})
				setLotData((prev) => {
					if (prev && prev.id === lot.id) {
						return null
					}
					map.setFeatureState({ source: "lots", id: lot.id }, { thickBorder: true })
					return lot
				})
			},
		},
		sections: {
			status: (e) => {
				let s = e.features[0].properties
				let sec = _.find(props.payload.public.sections, { id: s.Id })
				setSection(sec)
			},
		},
	}

	const zoomWork = {
		status: () => {
			//? Show lots
			if (map.getZoom() > zoomThreshold) {
				if (map.getLayer("sections") && map.getPaintProperty("sections", "fill-opacity") !== 0) {
					map.setPaintProperty("sections", "fill-opacity", 0)
					map.setPaintProperty("sections-outline", "line-opacity", 0)
				}
				if (!map.getLayer("lots")) {
					addLots()
				}
				if (!map.getLayer("pending-sales-circle")) {
					layerWork.addPendingCircles(map)
				}
			} else {
				//? Show sections
				if (!map.getLayer("sections")) {
					addSections(map)
				}
				if (map.getPaintProperty("sections", "fill-opacity") === 0) {
					map.setPaintProperty("sections", "fill-opacity", 0.75)
					map.setPaintProperty("sections-outline", "line-opacity", 1)
				}
				if (map.getLayer("pending-sales-circle")) map.removeLayer("pending-sales-circle")
				if (map.getLayer("lots")) {
					map.removeLayer("lots")
					map.removeLayer("lot-borders")
				}
			}
		},
		edit: () => {},
		filter: () => {},
	}

	useEffect(() => {
		getFullPropertyData()
	}, [])

	useEffect(() => {
		if (!map) return
		onZoom()
	}, [map?.getZoom()])

	useEffect(() => {
		if (
			props.activeProperties &&
			props.activeProperties.length &&
			props.activeProperties[0] !== fullPropertyData?.id
		) {
			//getFullPropertyData()
		}
	}, [props.activeProperties])

	useEffect(() => {
		if (fullPropertyData && props.payloadStatus) {
			initMap()
		}
	}, [fullPropertyData, props.payloadStatus])

	useEffect(() => {
		if (!map) return
		const cleanup = () => {
			// Remove all click event listeners first
			map.off("click", "lots", mapClickEvents.lots.status)
			map.off("click", "lots", mapClickEvents.lots.edit)
			map.off("click", "lots", mapClickEvents.lots.filter)
			map.off("click", "sections", mapClickEvents.sections.status)
			map.off("zoom", zoomWork.status)
			map.off("zoom", zoomWork.edit)
			map.off("zoom", zoomWork.filter)
		}
		cleanup()
		layerWork.resetLotBordersFeatureState()
		layerWork.resetLotFeatureState()
		setLotData(null)
		// Then add the appropriate listeners based on mode
		if (mode === "status") {
			map.on("click", "lots", mapClickEvents.lots.status)
			map.on("click", "sections", mapClickEvents.sections.status)
			if (map.getSource("pending-sales-centers")) {
				layerWork.addPendingCircles(map)
			}
		} else if (mode === "edit") {
			layerWork.removePendingCircles()
			layerWork.removeSections()
			layerWork.editInitFeatureStates()
			addLots()
			map.on("click", "lots", mapClickEvents.lots.edit)
			// Put feature states back to
		} else if (mode === "filter") {
			layerWork.removePendingCircles()
			layerWork.removeSections()
			addLots()
			map.on("click", "lots", mapClickEvents.lots.filter)
		}

		// Update paint properties
		if (map.getLayer("lots")) {
			map.setPaintProperty("lots", "fill-color", paintProperties.fillColors[mode])
			map.setPaintProperty("lots", "fill-opacity", paintProperties.fillOpacity[mode])
		}
		if (map.getLayer("lot-borders")) {
			map.setPaintProperty("lot-borders", "line-color", paintProperties.lineColor[mode])
			map.setPaintProperty("lot-borders", "line-width", paintProperties.lineWidth[mode])
		}
		// Remove all map zoom effects here:
		// Add zoom effects based on mode
		if (mode === "status") {
			map.on("zoom", zoomWork.status)
		} else if (mode === "edit") {
			map.on("zoom", zoomWork.edit)
		}

		// Universal zoom effect for lot labels
		map.on("zoom", () => {
			/* if (map.getZoom() > 16) {
				if (map.getLayer("lot-labels") && showingLabels) {
					map.setLayoutProperty("lot-labels", "visibility", "visible")
				}
			} else {
				if (map.getLayer("lot-labels")) {
					map.setLayoutProperty("lot-labels", "visibility", "none")
				}
			} */
		})

		// Cleanup function to remove listeners when component unmounts or mode changes
		return () => {
			if (map) {
				cleanup()
			}
		}
	}, [mode, map])

	// Add effect to update labels when lotLabels changes
	useEffect(() => {
		lotLabelsRef.current = lotLabels
		updateLotLabels(map)
	}, [lotLabels])

	useEffect(() => {
		if (!map || !map.getLayer("aerial")) return
		if (showAerial) {
			if (map.getLayer("aerial")) {
				map.setLayoutProperty("aerial", "visibility", "visible")
			}
		} else {
			map.setLayoutProperty("aerial", "visibility", "none")
		}
	}, [showAerial, map])

	useEffect(() => {
		if (!map || !map.getLayer("lots")) return
		if (showingLots) {
			map.setLayoutProperty("lots", "visibility", "visible")
		} else {
			map.setLayoutProperty("lots", "visibility", "none")
		}
	}, [showingLots, map])

	useEffect(() => {
		if (!map || !map.getLayer("lot-labels")) return
		if (showingLabels) {
			map.setLayoutProperty("lot-labels", "visibility", "visible")
		} else {
			map.setLayoutProperty("lot-labels", "visibility", "none")
		}
	}, [showingLabels, map])

	const getFullPropertyData = async () => {
		try {
			const data = await getData("getProperty", { id: props.activeProperties[0] })
			let d = data.data
			setLat(d.lat)
			setLng(d.lng)
			setZoom(15)
			setCurrentProperty(d.id)
			setFullPropertyData(d)
		} catch (err) {
			console.error(err)
		}
	}

	const onZoom = () => {
		if (!map) return
		//? this effect is just for when the zoom changes, while in status mode, and it's less than zoomThreshold and the lotData is not null, it wipes the lotData and resets the feature state.
		if (mode === "status" && lotData && map.getZoom() < zoomThreshold) {
			setLotData(false)
			layerWork.resetLotFeatureState()
			layerWork.resetLotBordersFeatureState()
		}
		// This is the lot labels and lots work.  takes into considering the showingLots, showingLabels, and zoom level.
		// first if the zoom is < 16, then no matter what, the labels are hidden.
		// if the zoom is > 16, then it checks the showingLabels state, if it's true, then it shows the labels, if it's false, then it hides the labels.
		if (map.getLayer("lot-labels")) {
			let labelsVis = map.getLayoutProperty("lot-labels", "visibility")
			if (map.getZoom() > 16) {
				if (showingLabels) {
					map.setLayoutProperty("lot-labels", "visibility", "visible")
				} else {
					map.setLayoutProperty("lot-labels", "visibility", "none")
				}
			} else {
				if (map.getLayer("lot-labels")) {
					map.setLayoutProperty("lot-labels", "visibility", "none")
				}
			}
		}

		// Now the next part is the lots, if the zoom is < zoomThreshold, then it hides the lots, if it's > zoomThreshold, then it checks the showingLots state, if it's true, then it shows the lots, if it's false, then it hides the lots.
		if (map.getZoom() > zoomThreshold) {
			if (showingLots) {
				map.setLayoutProperty("lots", "visibility", "visible")
			} else {
				map.setLayoutProperty("lots", "visibility", "none")
			}
		} else {
			if (map.getLayer("lots")) {
				map.setLayoutProperty("lots", "visibility", "none")
			}
		}
	}

	// Update lot labels on map move
	const updateLotLabels = (m) => {
		if (m && m.getLayer("lots") && m.getLayer("lot-labels")) {
			const features = m.queryRenderedFeatures({ layers: ["lots"] })
			// Reset highlighted state for all features
			if (lotsGeoRef.current && lotsGeoRef.current.features) {
				lotsGeoRef.current.features.forEach((feature) => {
					m.setFeatureState({ source: "lots", id: feature.id }, { highlighted: false })
				})
			}
			let geoData = lotsGeoRef.current

			const labelFeatures = features
				.map((feature) => {
					if (feature.geometry.type === "Polygon") {
						let label = ""
						const bounds = new mapboxgl.LngLatBounds()
						feature.geometry.coordinates[0].forEach((coord) => bounds.extend(coord))
						const center = bounds.getCenter()
						let val = lotLabelsRef.current.value
						if (val === "streetNum") {
							label = feature.properties.address ? feature.properties.address.split(" ")[0] : ""
						} else if (val === "lot_type") {
							let lookup = _.find(props.payload.public.lot_types, { id: feature.properties.lot_type })
							label = lookup ? lookup.name : ""
						} else if (val === "builder") {
							let lookup = _.find(props.payload.public.builders, { id: feature.properties.builder })
							label = lookup ? lookup.code : ""
						} else if (val === "floorplan") {
							let lookup = _.find(props.payload.public.floorplans, { id: feature.properties.floorplan })
							label = lookup ? lookup.name : ""
						} else if (val === "section") {
							let lookup = _.find(props.payload.public.sections, { id: feature.properties.section_id })
							label = lookup ? lookup.name : ""
						} else if (val === "lbs") {
							let lookup = _.find(props.payload.public.sections, { id: feature.properties.section_id })
							label = `${feature.properties.lot}-${feature.properties.block}-${lookup ? lookup.name : ""}`
						} else if (val === "is_featured") {
							if (feature.properties.is_featured === 1) {
								label = "Yes"
							} else {
								label = ""
							}
						} else if (val === "lot_premium_type") {
							let lookup = _.find(props.payload.public.lot_premium_types, {
								id: feature.properties.lot_premium_type,
							})
							label = lookup ? lookup.name : ""
						} else if (val === "site_type") {
							let string = ""
							let d = feature.properties.site_id
							if (d) {
								d = JSON.parse(d)
								_.forEach(d, (v) => {
									let lookup = _.find(props.payload.public.sites, { id: v })
									string += lookup ? lookup.name + ", " : ""
								})
							}

							label = string.slice(0, -2)
						} else if (val === "sale_price" || val === "base_price" || val === "premium") {
							label = feature.properties[val] ? numeral(feature.properties[val]).format("$0,0") : ""
						} else if (val?.includes("addl.")) {
							// This is an ADDL field.
							let full = _.find(geoData.features, { id: feature.id })
							let exp = val.split("addl.")[1].trim()
							if (full) {
								let v = full.properties?.addl?.[exp]
								if (v) {
									// This may require some tweaking if int 1 is valid and shouldn't be yes.
									if (v === 1) {
										label = "Yes"
									} else if (v === 0) {
										label = "No"
									} else {
										label = v
									}
									//? Now if this has a highlightColor, then also change the lots background color to whatever the highlightColor is.  But only the lot that this matches.
									if (lotLabelsRef?.current?.highlighted) {
										if (feature.id && v === 1) {
											m.setFeatureState({ source: "lots", id: feature.id }, { highlighted: true })
										}
									}
								}
							}
						} else {
							label = feature.properties[val] || ""
						}
						return {
							type: "Feature",
							geometry: {
								type: "Point",
								coordinates: [center.lng, center.lat],
							},
							properties: {
								label,
							},
						}
					}
				})
				.filter(Boolean)
			m.getSource("lot-labels").setData({
				type: "FeatureCollection",
				features: labelFeatures,
			})
		}
	}

	const addLots = () => {
		if (!map) return
		// Add outline layer for lots
		if (!map.getLayer("lot-borders")) {
			map.addLayer({
				id: "lot-borders",
				type: "line",
				source: "lots",
				paint: {
					//"line-color": ["case", ["boolean", ["feature-state", "active"], false], "#000", "#EFEFEF"],
					//"line-width": ["case", ["boolean", ["feature-state", "active"], false], 5, 2],
					"line-color": paintProperties.lineColor["status"],
					"line-width": paintProperties.lineWidth["status"],
				},
			})
		}
		// Add lines layer for lot outlines
		if (!map.getLayer("lots")) {
			map.addLayer(
				{
					id: "lots",
					type: "fill",
					source: "lots",
					slot: "top",
					paint: {
						"fill-color": paintProperties.fillColors["status"],
						"fill-opacity": paintProperties.fillOpacity["status"],
					},
				},
				"lot-borders"
			)

			// Wait for the layer to be loaded
			// Create a source for lot labels
			if (!map.getSource("lot-labels")) {
				map.addSource("lot-labels", {
					type: "geojson",
					data: {
						type: "FeatureCollection",
						features: [],
					},
				})
			}

			// Add a symbol layer for lot labels
			if (!map.getLayer("lot-labels")) {
				map.addLayer({
					id: "lot-labels",
					type: "symbol",
					source: "lot-labels",
					layout: {
						"text-field": ["get", "label"],
						"text-size": 11,
						"text-anchor": "center",
						"text-allow-overlap": true,
					},
					paint: {
						"text-color": "#111",
					},
				})
			}
		}
		if (!map.getSource("pending-sales-centers") && pendingCenters.current) {
			map.addSource("pending-sales-centers", {
				type: "geojson",
				data: pendingCenters.current,
			})
			if (mode === "status") layerWork.addPendingCircles(map)
		}
	}

	const addSections = (map) => {
		if (!map) return
		let sectionLabels = []
		if (fullPropertyData.section_geo) {
			let stats = calculateSectionHealth(props)
			// Update the remaining_months property for each feature
			fullPropertyData.section_geo.features.forEach((feature) => {
				feature.id = feature.properties.Id
				let stat = _.find(stats, { section_id: feature.properties.Id })
				if (stat) {
					feature.properties.remaining_months = stat.remaining_months_4 || 0
					feature.properties.unsold = stat.unsold || false
				}
				let center = polygonCenter(feature.geometry.coordinates[0])
				if (center) {
					let sec = _.find(props.payload.public.sections, { id: feature.properties.Id })
					sectionLabels.push({
						text: sec.name,
						coordinates: [center.lng, center.lat],
					})
				}
			})
			if (!map.getSource("sections")) {
				map.addSource("sections", {
					type: "geojson",
					data: fullPropertyData.section_geo,
				})
			}
			// Section fill
			// Keep track of the currently selected section ID
			let selectedSectionId = null

			if (!map.getLayer("sections")) {
				map.addLayer({
					id: "sections",
					type: "fill",
					source: "sections",
					paint: {
						"fill-outline-color": "#FFFFFF",
						"fill-color": [
							"case",
							["boolean", ["get", "unsold"], false],
							"#BAF6D0",
							["==", ["get", "remaining_months"], 0],
							"#8d8d8d",
							["<=", ["get", "remaining_months"], 5],
							"#F77170",
							["<", ["get", "remaining_months"], 10],
							"#FECAC9",
							["<=", ["get", "remaining_months"], 12],
							"#FED6AA",
							"#BAF6D0",
						],
						"fill-opacity": [
							"case",
							["==", ["get", "Id"], ["literal", null]], // Default case when no section selected
							0.75,
							["==", ["get", "Id"], ["literal", selectedSectionId]], // Selected section case
							1,
							0.75, // All other sections
						],
					},
				})
			}

			// Add outline layer
			map.addLayer({
				id: "sections-outline",
				type: "line",
				source: "sections",
				paint: {
					"line-color": "#555",
					"line-width": 1,
				},
			})

			// Add click handler
			map.on("click", "sections", (e) => {
				if (map.getZoom() > zoomThreshold) return
				if (e.features.length > 0) {
					const clickedSectionId = e.features[0].id

					// Toggle selection
					if (selectedSectionId === clickedSectionId) {
						selectedSectionId = null
					} else {
						selectedSectionId = clickedSectionId
					}

					// Update the fill-opacity expression with the new selectedSectionId
					map.setPaintProperty("sections", "fill-opacity", [
						"case",
						["==", ["get", "Id"], selectedSectionId],
						1,
						0.75,
					])
				}
			})
			// Add section labels
			sectionLabels.forEach((label) => {
				const labelElement = document.createElement("div")
				labelElement.className = "section-label"
				labelElement.textContent = label.text
				labelElement.style.fontWeight = "bold"
				labelElement.style.textShadow = "1px 1px 2px rgba(0,0,0,0.3)"
				labelElement.style.color = "white"
				labelElement.style.backgroundColor = "#111"
				labelElement.style.padding = "3px 6px"

				new mapboxgl.Marker({
					element: labelElement,
					anchor: "center",
				})
					.setLngLat(label.coordinates)
					.addTo(map)
			})
		}
	}

	const initMap = () => {
		if (!mapboxgl.supported()) {
			toast.error("Your browser does not support Mapbox GL")
			return
		}
		if (fullPropertyData && mapContainer.current) {
			let center = [lng, lat]
			const map = new mapboxgl.Map({
				container: mapContainer.current,
				//theme: "monochrome",
				//style: mapType,
				//style: "mapbox://styles/mapbox/standard-satellite",
				style: "mapbox://styles/aaroncrawford/cm6k4kqrd010a01qm22sgbzun",
				center,
				pitch: 10,
				zoom,
				minZoom: 13,
				maxZoom: 20,
				attributionControl: false,
				preserveDrawingBuffer: true,
			})
			map.on("style.load", () => {
				map.setConfigProperty("basemap", "theme", "faded")
			})
			map.addControl(new mapboxgl.NavigationControl(), "bottom-right")

			map.on("moveend", () => {
				setLng(map.getCenter().lng.toFixed(4))
				setLat(map.getCenter().lat.toFixed(4))
				setZoom(map.getZoom().toFixed(2))
			})

			map.on("mouseenter", "lots", () => {
				map.getCanvas().style.cursor = "pointer"
			})

			map.on("mouseleave", "lots", () => {
				map.getCanvas().style.cursor = "default"
			})

			map.on("load", async () => {
				let data = await buildGeoJson()
				// Move the event listener here after map is initialized
				map.on("moveend", () => updateLotLabels(map))
				lotsGeoRef.current = data
				console.log(data)
				map.addSource("lots", {
					type: "geojson",
					data,
				})
				pendingCenters.current = {
					type: "FeatureCollection",
					features: data.features
						.filter((f) => f.properties.sale_id && !f.properties.closing_date)
						.map((feature) => {
							const bounds = new mapboxgl.LngLatBounds()
							feature.geometry.coordinates[0].forEach((coord) => bounds.extend(coord))
							const center = bounds.getCenter()
							return {
								type: "Feature",
								geometry: { type: "Point", coordinates: [center.lng, center.lat] },
								properties: feature.properties,
							}
						}),
				}
				//Aerial check
				if (props.payload.satellite?.length) {
					let shots = _.filter(props.payload.satellite, { property: currentProperty })
					let latest = _.maxBy(shots, "capture_time")
					if (latest) {
						// Add raster tileset layer
						map.addSource("aerial", {
							type: "raster",
							url: `mapbox://${latest.tileset}`, // Replace with your tileset ID
							//tileSize: 256,
						})
						map.addLayer({
							id: "aerial",
							type: "raster",
							source: "aerial",
							minzoom: 0,
							maxzoom: 22,
							paint: {
								//"raster-opacity": 0.8,
								//"raster-fade-duration": 0,
							},
							slot: "middle",
						})
					}
					setDroneMode(true)
					setShowAerial(true)
					setAerialData(latest)
				}
				addSections(map)
				props.loadingStatus(false)
				setMap(map)
			})
		}
	}

	const buildGeoJson = async () => {
		let property
		if (user?.group === 13 && user?.activeProperties.length > 1) {
			property = _.find(props.payload.public.properties, { id: currentProperty })
		} else if (props.activeProperties.length == 1) {
			property = _.find(props.payload.public.properties, { id: props.activeProperties[0] })
		}
		if (property) {
			let geo = await getGeo(property.id)
			let model = {
				type: "FeatureCollection",
				crs: {
					type: "name",
					properties: {
						name: "urn:ogc:def:crs:OGC:1.3:CRS84",
					},
				},
				features: [],
			}
			_.forEach(geo.geo.features, (v) => {
				if (!v.geometry.coordinates.length) {
					return
				}
				v.id = v.properties.id
				model.features.push(v)
			})
			return model
		} else {
			toast.error("Cannot find property.")
		}
	}

	const getGeo = async (property) => {
		var user = localStorage.getItem("user")
		return new Promise((resolve, reject) => {
			axios
				.post(settings.ep + "/getGeo", { property: property }, { headers: { Authorization: `Bearer ${user}` } })
				.then((response) => {
					if (response.data.status == 200) {
						resolve(response.data)
					} else {
						let err = new Error()
						err.message = response.data.message
						err.status = response.data.status
						reject(err)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	}

	const sectionTable = () => {
		let ret = []
		let store = {}
		let totals = {
			total: 0,
			sold: 0,
			closed: 0,
			available: 0,
			builder_owned: 0,
			dev_owned: 0,
			salesOps: 0,
			vdl_builder: 0,
			vdl_developer: 0,
		}
		_.forEach(props.payload.exec.lots, (r) => {
			// Build first objects
			if (!_.has(store, `${r.section_id}`)) {
				_.set(store, `${r.section_id}`, {
					total: 0,
					sold: 0,
					closed: 0,
					builderOwned: 0,
					devOwned: 0,
					salesOps: 0,
					vdl_builder: 0,
					vdl_developer: 0,
					specs_uc: 0,
					specs_complete: 0,
					buyer_uc: 0,
					buyer_complete: 0,
				})
			}
			store[r.section_id].total++
			if (r.closing_date) {
				store[r.section_id].closed++
			} else if (r.lot_status == "Contract") {
				store[r.section_id].sold++
			} else if (r.builder && !r.sale_date) {
				store[r.section_id].builderOwned++
			} else if (!r.builder) {
				store[r.section_id].devOwned++
			}

			if ((r.builder && !r.sale_date) || (!r.builder && !r.closing_date && !r.sale_date)) {
				store[r.section_id].salesOps++
			}
			if (helpers.isBuilderVDL(r)) {
				store[r.section_id].vdl_builder++
			} else if (!r.takedown_date) {
				store[r.section_id].vdl_developer++
			}

			if (r.start_date && !r.complete_date && !r.sale_date && !r.model) {
				store[r.section_id].specs_uc++
			}
			if (r.complete_date && !r.sale_date && !r.model) {
				store[r.section_id].specs_complete++
			}
			if (r.sale_date && !r.closing_date && !r.complete_date && r.start_date) {
				store[r.section_id].buyer_uc++
			}
			if (r.complete_date && r.sale_date && !r.closing_date) {
				store[r.section_id].buyer_complete++
			}
		})
		let sections = _.filter(props.payload.public.sections, (v) => v.property == props.activeProperties[0])
		_.forEach(sections, (s) => {
			if (_.has(store, s.id)) {
				store[s.id].platted_lots = s.platted_lots
			}
		})
		_.forEach(store, (r, k) => {
			let secId = parseInt(k)
			let available = r.total - r.sold
			let name = _.find(props.payload.public.sections, { id: secId })
			name = name ? name.name : ""
			totals.total += r.total
			totals.sold += r.sold
			totals.available += r.available
			totals.builder_owned += r.builderOwned
			totals.dev_owned += r.dev_owned
			let percent = (r.sold + r.closed) / r.total
			let row = {
				section: name,
				total: r.total,
				sold: r.sold,
				closed: r.closed,
				available: available,
				percent_sold: percent,
				builder_owned: r.builderOwned,
				dev_owned: r.devOwned,
				percent,
				salesOps: r.salesOps,
				vdl_builder: r.vdl_builder,
				vdl_developer: r.vdl_developer,
				specs_uc: r.specs_uc,
				specs_complete: r.specs_complete,
				buyer_uc: r.buyer_uc,
				buyer_complete: r.buyer_complete,
				platted_lots: r.platted_lots,
			}
			ret.push(row)
		})
		return ret
	}

	const polygonCenter = (coordinates) => {
		if (!coordinates || !coordinates.length) return null

		// Create bounds and get geometric center
		const bounds = new mapboxgl.LngLatBounds()
		coordinates.forEach((coord) => {
			bounds.extend(coord)
		})
		const center = bounds.getCenter()

		// Create a point from center coordinates
		const point = [center.lng, center.lat]

		// Check if point is inside polygon using ray casting algorithm
		const inside = (point, vs) => {
			let x = point[0],
				y = point[1]
			let inside = false
			for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
				let xi = vs[i][0],
					yi = vs[i][1]
				let xj = vs[j][0],
					yj = vs[j][1]
				let intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
				if (intersect) inside = !inside
			}
			return inside
		}

		// If center is inside polygon, return it
		if (inside(point, coordinates)) {
			return center
		}

		// If not inside, find nearest point inside polygon
		let nearestPoint = null
		let minDist = Infinity

		// Sample points in polygon by creating a grid
		const gridSize = 10 // Adjust for precision vs performance
		const bbox = bounds.toArray()
		const xStep = (bbox[1][0] - bbox[0][0]) / gridSize
		const yStep = (bbox[1][1] - bbox[0][1]) / gridSize

		for (let x = bbox[0][0]; x <= bbox[1][0]; x += xStep) {
			for (let y = bbox[0][1]; y <= bbox[1][1]; y += yStep) {
				const testPoint = [x, y]
				if (inside(testPoint, coordinates)) {
					const dist = Math.pow(x - center.lng, 2) + Math.pow(y - center.lat, 2)
					if (dist < minDist) {
						minDist = dist
						nearestPoint = new mapboxgl.LngLat(x, y)
					}
				}
			}
		}

		return nearestPoint || center // Fallback to center if no point found
	}

	const builderTable = () => {
		var ret = []
		var store = {}
		_.forEach(props.payload.exec.lots, (r) => {
			// Build first objects
			let path = `${r.builder}.${r.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(
					store,
					path,
					{
						total: 0,
						sold: 0,
						closed: 0,
						builderOwned: 0,
						vdl: 0,
						specs_uc: 0,
						specs_complete: 0,
						buyer_uc: 0,
						buyer_complete: 0,
					},
					Object
				)
			}
			store[r.builder][r.lot_type].total++
			if (r.closing_date) {
				store[r.builder][r.lot_type].closed++
			} else if (r.lot_status == "Contract") {
				store[r.builder][r.lot_type].sold++
			} else if (r.builder && !r.sale_date) {
				store[r.builder][r.lot_type].builderOwned++
			}

			if (helpers.isBuilderVDL(r)) {
				store[r.builder][r.lot_type].vdl++
			}

			if (r.start_date && !r.complete_date && !r.sale_date && !r.model) {
				store[r.builder][r.lot_type].specs_uc++
			}
			if (r.complete_date && !r.sale_date && !r.model) {
				store[r.builder][r.lot_type].specs_complete++
			}
			if (r.sale_date && !r.closing_date && !r.complete_date && r.start_date) {
				store[r.builder][r.lot_type].buyer_uc++
			}
			if (r.complete_date && r.sale_date && !r.closing_date) {
				store[r.builder][r.lot_type].buyer_complete++
			}
		})

		_.forEach(store, (l1, builder) => {
			_.forEach(l1, (l2, type) => {
				let b = _.find(props.payload.public.builders, { id: parseInt(builder) })
				let lt = _.find(props.payload.public.lot_types, { id: parseInt(type) })
				if (!b || !lt) {
					return
				}
				let percent = (l2.sold + l2.closed) / l2.total
				let row = {
					builder: b.name,
					lot_type: lt.name,
					total: l2.total,
					sold: l2.sold,
					closed: l2.closed,
					builderOwned: l2.builderOwned,
					percent_sold: percent,
					vdl: l2.vdl,
					specs_uc: l2.specs_uc,
					specs_complete: l2.specs_complete,
					buyer_uc: l2.buyer_uc,
					buyer_complete: l2.buyer_complete,
				}
				ret.push(row)
			})
		})
		return ret
	}

	const openLot = (id) => {
		let r = _.find(props.payload.exec.lots, { id: id })
		if (r.model == 1) {
			r.sale_status = "Model"
		} else if (r.closing_date) {
			r.sale_status = "Closed"
		} else if (!r.closing_date && r.sale_id) {
			r.sale_status = "Contract"
		} else if (r.lot_status == "Bustout") {
			r.sale_status = "Bustout"
		} else {
			r.sale_status = ""
		}
		if (!r.takedown_date) {
			r.const_status = ""
		} else if (r.complete_date) {
			r.const_status = "Complete"
		} else if (r.start_date) {
			r.const_status = "Slab"
		} else {
			r.const_status = "Vacant"
		}
		//let data = { id: id, property: props.activeProperties[0] }
		setModal(true)
		setModalData(r)
	}

	const closeLot = () => {
		setModal(false)
		setModalData(false)
	}

	const buildMatchedList = (filters) => {
		try {
			if (!map) return
			let l = lotsGeoRef.current
			let ret = []
			_.forEach(l.features, (v, k) => {
				let accepted = true
				_.forEach(filters, (r) => {
					let id = r.id
					if (r?.id?.includes(".")) id = r.id.split(".")[1] // s.sale_date split to only sale_date
					// These are al conditions where they all need to be met
					// Text
					let lotVal = v.properties[id]
					let l = v.properties
					let skip = false
					try {
						//? Special cases first
						if (r.id === "lot_status") {
							if (r.low.includes("Available Home")) {
								if (
									!l.sale_id &&
									l.takedown_date &&
									l.builder &&
									l.start_date &&
									l.complete_date &&
									!l.model
								) {
									skip = true
								}
							}
							if (r.low.includes("Under Construction")) {
								if (
									!l.sale_id &&
									l.takedown_date &&
									l.builder &&
									l.start_date &&
									!l.complete_date &&
									!l.model
								) {
									skip = true
								}
							}
							if (r.low.includes("Unsold")) {
								if (!l.sale_id) {
									skip = true
								}
							}
						}
						if (r.id === "spec_status") {
							if (r.low.includes("Available Home")) {
								if (
									!l.sale_id &&
									l.takedown_date &&
									l.builder &&
									l.start_date &&
									l.complete_date &&
									!l.model
								) {
									skip = true
								}
							}
							if (r.low.includes("Under Construction")) {
								if (
									!l.sale_id &&
									l.takedown_date &&
									l.builder &&
									l.start_date &&
									!l.complete_date &&
									!l.model
								) {
									skip = true
								}
							}
						}
						//? end special cases
						// Regular conditions
						if (!skip) {
							if (!lotVal) accepted = false
							if (r.type == "text") {
								let input = _.toLower(_.toString(r.low))
								let row = _.toLower(_.toString(lotVal))
								if (!row.includes(input)) {
									accepted = false
								}
							} else if (r.type == "select") {
								if (Array.isArray(r.low) && !r.low.includes(lotVal)) {
									accepted = false
								}
							} else if (r.type == "number") {
								if (lotVal < parseInt(r.low) || lotVal > parseInt(r.high)) accepted = false
							} else if (r.type == "date") {
								if (lotVal < r.low.unix() || lotVal > r.high.unix()) accepted = false
							} else if (r.type == "boolean") {
								let selectionVal = r.low == "Yes" ? true : false
								if (selectionVal && !lotVal) accepted = false
								if (!selectionVal && lotVal) accepted = false
							}
						}
					} catch (e) {
						console.error(e)
					}
				})
				if (accepted) ret.push(l.features[k])
			})
			layerWork.resetLotFeatureState()
			_.forEach(ret, (v) => {
				map.setFeatureState({ source: "lots", id: v.id }, { active: true })
			})
		} catch (e) {
			console.warn(e)
		}
	}

	const Legend = () => {
		let left = <div className="flex-1"></div>
		let middle = <div className="flex-1"></div>
		if (mode === "status" && zoom <= zoomThreshold) {
			left = (
				<ul className="legend__list flex-5">
					<li>
						<span className="bg-[#8d8d8d]" />
						Closed Out
					</li>
					<li>
						<span className="bg-red-400" />
						Sellout &lt; 5 Months
					</li>
					<li>
						<span className="bg-red-200" />
						Sellout 5-9 Months
					</li>
					<li>
						<span className="bg-orange-200" />
						Sellout 9-12 Months
					</li>
					<li>
						<span className="bg-green-200" />
						Sellout 12+ Months
					</li>
				</ul>
			)
		} else if (mode === "status" && zoom >= zoomThreshold) {
			left = (
				<ul className="legend__list flex-4 flex">
					<li>
						<span style={{ backgroundColor: colors.builderNoTakedown }} />
						Builder Assigned
					</li>
					<li>
						<span style={{ backgroundColor: colors.takedown }} />
						Taken Down
					</li>
					<li>
						<span style={{ backgroundColor: colors.start }} />
						Start
					</li>
					<li>
						<span style={{ backgroundColor: colors.complete }} />
						Complete
					</li>
					<li>
						<span style={{ backgroundColor: colors.closed }} />
						Closed To Homebuyer
					</li>
					<li>
						<span style={{ backgroundColor: colors.developer }} />
						Developer Lot
					</li>
					<li>
						<span style={{ backgroundColor: colors.model }} />
						Model
					</li>
					<li className="legend__pending">
						<img src="/img/map-circle-red.svg" className="lotStatus__circle" /> Sale Pending
					</li>
				</ul>
			)
		}
		if (user?.group === 1 && zoom >= 16) {
			let options = [
				{ value: "builder", label: "Builders" },
				{ value: "lot_type", label: "Lot Types" },
				{ value: "streetNum", label: "Street Number" },
				{ value: "floorplan", label: "Floorplan" },
				{ value: "sale_price", label: "Sale Price" },
				{ value: "section", label: "Section" },
				{ value: "block", label: "Block" },
				{ value: "lot", label: "Lot" },
				{ value: "lbs", label: "Lot/Block/Section" },
				{ value: "base_price", label: "Base Price" },
				{ value: "premium", label: "Premium" },
				{ value: "true_up", label: "True Up" },
				{ value: "lot_premium_type", label: "Lot Premium Type" },
				{ value: "site_type", label: "Site Type" },
				{ value: "is_featured", label: "High Visibility" },
			]
			if (settings.lotStatusCustomOptions) {
				options = [...options, ...settings.lotStatusCustomOptions]
			}
			middle = (
				<div className={classNames(`flex-1 flex justify-end`, {})}>
					<div
						className={classNames(`pr-4 mb-2 max-w-56 w-full`, {
							"w-full": mode === "status",
						})}>
						<Select
							options={options}
							value={lotLabels}
							onChange={(v) => {
								setLotLabels(v)
							}}
							onBlur={() => {}}
						/>
					</div>
				</div>
			)
		}
		return (
			<div className="flex justify-between h-10">
				<div className="flex-4 flex justify-between">
					{left}
					{middle}
				</div>
				{user?.group === 1 && (
					<div className="lotStatus__mode">
						<div
							className={classNames("", { active: mode === "status" })}
							onClick={() => setMode("status")}>
							Status
						</div>
						<div className={classNames("", { active: mode === "edit" })} onClick={() => setMode("edit")}>
							Edit
						</div>
						<div
							className={classNames("", { active: mode === "filter" })}
							onClick={() => setMode("filter")}>
							Filter
						</div>
					</div>
				)}
			</div>
		)
	}

	const Status = () => {
		if (mode !== "status") return ""
		return (
			<>
				{lotData && (
					<h3 className="bg-blue w-full px-1 py-2 text-white text-base font-medium mb-2">Lot Info</h3>
				)}
				<InfoWindow lot={lotData} openLot={openLot} />
				<h3 className="bg-blue w-full px-1 py-2 text-white text-base font-medium mb-2">Section Info</h3>
				<SectionInfoWindow section={section} props={props} />
			</>
		)
	}

	const Edit = () => {
		if (mode !== "edit" || user?.group !== 1) return ""
		return (
			<>
				<h3 className="bg-blue w-full px-2 py-2 text-white font-medium mb-2">Lots Chosen</h3>
				{_.map(editingLots, (editingLot, index) => {
					let lot = _.find(props.payload.exec.lots, { id: editingLot })
					return (
						<div key={index} className="lot-status-item">
							<p className="py-1 text-xs text-blue px-2 border-b border-b-blue font-semibold">
								{lot?.address || "Lot not found"}
							</p>
						</div>
					)
				})}
				{editingLots.length === 0 && (
					<>
						<p className="text-gray-600">No lots selected.</p>
					</>
				)}
				{editingLots.length !== 0 && (
					<>
						<div
							className="text-center border border-blue py-2 text-lg mt-5 cursor-pointer hover:bg-blue hover:text-white transition duration-100"
							onClick={() => setEditOpen(true)}>
							Edit {editingLots.length} Lots
						</div>
					</>
				)}
			</>
		)
	}

	const EditWindow = (props) => {
		const [selectOptions, setSelectOptions] = useState([])
		const lotIndex = LotColumnIndex()
		const [stageTypeValue, setStageTypeValue] = useState(false)
		const [value, setValue] = useState(null)
		const [focused, setFocused] = useState(false) // for stupid datepicker

		useEffect(() => {
			load()
		}, [props.activeProperties])

		const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
			let opts = []
			let currentYear = moment().year() + 2
			for (let i = currentYear - 25; i <= currentYear; i++) {
				opts.push(
					<option value={i} key={i}>
						{i}
					</option>
				)
			}
			return (
				<div style={{ display: "flex", justifyContent: "center" }}>
					<div>
						<select value={month.month()} onChange={(e) => onMonthSelect(month, e.target.value)}>
							{moment.months().map((label, value) => (
								<option value={value} key={value}>
									{label}
								</option>
							))}
						</select>
					</div>
					<div>
						<select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
							{opts}
						</select>
					</div>
				</div>
			)
		}
		const load = () => {
			let opts = []
			_.forEach(lotIndex, (v) => {
				let ind = _.findIndex(translations, { name: v.id })
				// Split is due to the ids having the sql, such as b.primary_first, so check for that
				let split = v.id.split(".")
				let splitIndex
				if (split.length > 1) {
					splitIndex = _.findIndex(translations, { name: split[1] })
				}
				if (v.Label) {
					v.english = v.Label
					opts.push(v)
				} else if (ind !== -1) {
					v.english = translations[ind].english
					opts.push(v)
				} else if (splitIndex && splitIndex !== -1) {
					v.english = translations[splitIndex].english
					opts.push(v)
				} else {
					v.english = _.startCase(v.id.replace("_", " "))
					opts.push(v)
				}
			})
			let f = _.map(opts, (v) => {
				return { label: v.english, value: v.id, ...v }
			})
			f = _.sortBy(f, "english")
			setSelectOptions(f)
		}
		const update = () => {
			let val = value
			if (moment.isMoment(value)) val = value.unix()
			let data = {
				property: props.activeProperties[0],
				lots: props.editingLots,
				field: stageTypeValue.id,
				value: val,
				action: "massUpdateProperty",
			}
			axios
				.post(settings.ep + "/mainIngest", data, {
					headers: { Authorization: `Bearer ${localStorage.getItem("user")}` },
				})
				.then((response) => {
					if (response.data.status == 200) {
						toast.success("Lots updated.")
						props.setEditOpen(false)
					} else {
						toast.error(response.data.message)
					}
				})
				.catch((error) => {
					console.log(error)
					//toast.error("Error updating lots.")
				})
		}
		let type = _.get(stageTypeValue, "type")
		let opts = [] // if they select a Select (not date, text, etc)
		if (type == "select") {
			if (stageTypeValue && stageTypeValue.opts) {
				opts = _.map(stageTypeValue.opts, (v) => {
					return { label: v, value: v }
				})
			} else if (stageTypeValue && stageTypeValue.global) {
				//? Global is like site types - culdesac, corner etc.  Things that are in every property.  Mark Global = true in lotcolumnindex.js
				_.forEach(props.payload.public[stageTypeValue.public], (v) => {
					opts.push({ label: v.name, value: v.id })
				})
			} else if (stageTypeValue && stageTypeValue.public) {
				_.forEach(props.payload.public[stageTypeValue.public], (v) => {
					if (v.property && v.property == props.activeProperties[0]) {
						opts.push({ label: v.name, value: v.id })
					} else if (
						v.properties &&
						Array.isArray(v.properties) &&
						v.properties.includes(props.activeProperties[0])
					) {
						opts.push({ label: v.name, value: v.id })
					}
				})
			}
		}
		return (
			<Modal
				classNames={{ modal: "modalForm mid" }}
				open={props.editOpen}
				onClose={() => props.setEditOpen(false)}
				center>
				<h2 className="pt-0">Mass Edit Lots</h2>
				<div className="flex justify-between">
					<div className="flex-2 pr-4">
						<h3 className="pt-3">Property To Update</h3>
						<div className="pt-4">
							<Select
								value={stageTypeValue}
								options={selectOptions}
								onChange={(v) => {
									setStageTypeValue(v)
									setValue(null)
								}}
								isClearable={true}
							/>
							{type == "number" && (
								<div className="flex py-6">
									<NumberFormat
										thousandSeparator={true}
										onValueChange={(v) => setValue(v.value)}
										placeholder="Value"
										className="mr-4 input border border-blue"
										value={value}
									/>
								</div>
							)}
							{type == "date" && (
								<div className="flex py-6">
									<div className="mr-4">
										<SingleDatePicker
											id="value"
											numberOfMonths={1}
											focused={focused} //so dumb
											onFocusChange={({ focused }) => setFocused(focused)}
											date={value}
											renderMonthElement={renderMonthElement}
											onDateChange={(v) => {
												setValue(v)
											}}
											placeholder="Date"
											isOutsideRange={(day) => {
												return false
											}}
										/>
									</div>
								</div>
							)}
							{type == "text" && (
								<div className="flex py-6">
									<input
										type="text"
										value={value || ""}
										className="input border border-blue px-1 py-1"
										onChange={(e) => {
											setValue(e.target.value)
										}}
									/>
								</div>
							)}
							{type == "boolean" && (
								<div className="py-6">
									<ReactSelect
										value={value}
										options={[
											{ value: false, label: "No" },
											{ value: true, label: "Yes" },
										]}
										onChange={(k, v) => {
											setValue(v)
										}}
										onBlur={() => {}}
										isClearable={true}
									/>
								</div>
							)}
							{type == "select" && (
								<div className="py-6">
									<ReactSelect
										value={value}
										options={opts}
										onChange={(k, v) => {
											setValue(v)
										}}
										isMulti={stageTypeValue?.isArray ? true : false}
										isClearable={true}
										onBlur={() => {}}
									/>
								</div>
							)}
							{value !== undefined && value !== null && (
								<div
									className="btn-success text-center py-2 px-4 w-full cursor-pointer hover:opacity-80 transition-opacity duration-100"
									onClick={update}>
									UPDATE
								</div>
							)}
						</div>
					</div>
					<div className="flex-1">
						<p className="bg-blue px-2 py-1 text-white font-semibold">Lots Chosen</p>
						<ul>
							{_.map(props.editingLots, (editingLot, index) => {
								let lot = _.find(props.payload.exec.lots, { id: editingLot })
								return (
									<li
										className="text-xs py-1 border border-b border-b-blue font-semibold px-2"
										key={index}>
										{lot?.address || "Lot not found"}
									</li>
								)
							})}
						</ul>
					</div>
				</div>
			</Modal>
		)
	}

	const quickStatChange = (quickStat) => {
		if (mode === "filter" && quickStat) {
			if (map && map.getSource("lots")) {
				const features = lotsGeoRef.current.features
				features.forEach((feature) => {
					const props = feature.properties
					let isActive = false
					// Check if any of the quick stats match
					quickStat.forEach((stat) => {
						switch (stat) {
							case "Builder Assigned":
								if (!props.takedown_date && props.builder) isActive = true
								break
							case "Builder VDL":
								if (helpers.isBuilderVDL(props, null)) isActive = true
								break
							case "Developer VDL":
								if (!props.takedown_date) isActive = true
								break
							case "Under Construction":
								if (props.start_date && !props.complete_date) isActive = true
								break
							case "Completed Specs":
								if (props.complete_date && !props.closing_date) isActive = true
								break
							case "Sale Pending":
								if (props.sale_id && !props.closing_date) isActive = true
								break
						}
					})

					map.setFeatureState({ source: "lots", id: props.id }, { active: isActive })
				})
			}
		} else {
			layerWork.resetLotBordersFeatureState()
			layerWork.resetLotFeatureState()
		}
	}


	const filterChange = (filters) => {
		if (filters.length === 0) {
			layerWork.resetLotBordersFeatureState()
			layerWork.resetLotFeatureState()
			return
		}
		buildMatchedList(filters)
	}

	return (
		<div className="">
			<div className="imageGroup">
				<Title title="Lot Status" showDate={false} />
				{/* <div className="bg-red-600 text-white inline-block px-4 py-2">{zoom}</div> */}
				{droneMode && (
					<div className="aerial flex px-2 items-center">
						<i className="fa-solid fa-drone-front text-blue text-lg"></i>
						<div className="switch pl-2" onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() => setShowAerial(!showAerial)}
								checked={showAerial}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={16}
								width={30}
							/>
							<p className="text-xs">Showing {showAerial ? "Aerial" : "No Aerial"}</p>
						</div>
						<div className="switch pl-2" onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() => setShowingLots(!showingLots)}
								checked={showingLots}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={16}
								width={30}
							/>
							<p className="text-xs">{showingLots ? "Showing Lots" : "Hiding Lots"}</p>
						</div>
						<div className="switch pl-2" onClick={(e) => e.stopPropagation()}>
							<Switch
								onChange={() => setShowingLabels(!showingLabels)}
								checked={showingLabels}
								checkedIcon={false}
								uncheckedIcon={false}
								key={"switch"}
								id={"switch"}
								height={16}
								width={30}
							/>

							<p className="text-xs">{showingLabels ? "Showing Labels" : "Hiding Labels"}</p>
						</div>
						{aerialData ? (
							<p className="text-xs font-semibold bg-blue text-white px-2 py-[1px] ml-4 rounded-md">
								Latest shot as of {moment.unix(aerialData.capture_time).format("M/DD/YY")}
							</p>
						) : (
							""
						)}
					</div>
				)}
				<Legend />
				<div className="">
					<div className="flex w-full h-[70vh]">
						<div className="lotStatus__map" ref={mapContainer} />
						<div className="lotStatus__mapInfo">
							{Status()}
							{Edit()}
							<Filter
								map={map}
								filterChange={filterChange}
								quickStatChange={quickStatChange}
								mode={mode}
								lotData={lotData}
								openLot={openLot}
								setLotData={setLotData}
								layerWork={layerWork}
								{...props}
							/>
						</div>
					</div>
				</div>
			</div>
			{user?.group == 1 ? (
				<div className="imageGroup">
					<div className="content">
						<h2>By Section</h2>
						<p className="text-xs">VDL = Vacant Developed Lot</p>
						<FullTable
							data={sectionTable()}
							columns={lotStatusBySectionColumns}
							name="lotStatus__section"
							title="Lot Status by Section"
							pageSize={10}
						/>
						<h2>By Builder + Lot Type</h2>
						<p className="text-xs">VDL = Vacant Developed Lot</p>
						<FullTable
							data={builderTable()}
							columns={lotStatusByBuilderColumns}
							name="lotStatus__builderLotType"
							title="Lot Status by Builder and Lot Type"
							pageSize={10}
						/>
					</div>
				</div>
			) : (
				""
			)}
			<EditWindow
				editOpen={editOpen}
				setEditOpen={setEditOpen}
				editingLots={editingLots}
				payload={props.payload}
				activeProperties={props.activeProperties}
			/>
			<LotModal open={modal} data={modalData} onClose={closeLot} closeOnSave={true} />
		</div>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(LotStatus)
